import ResultNotification from './ResultNotification';

export default ResultNotification;